import type { StateCreator } from 'zustand';
import { devtools } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';
import { shallow } from 'zustand/shallow';
import { createWithEqualityFn } from 'zustand/traditional';

interface StateCreatorOptions<State, Actions> {
  state: State;
  actions: (
    set: Parameters<
      StateCreator<
        State & { actions: Actions },
        [['zustand/immer', never], ['zustand/devtools', unknown]]
      >
    >[0],
    get: Parameters<
      StateCreator<
        State & { actions: Actions },
        [['zustand/immer', never], ['zustand/devtools', unknown]]
      >
    >[1]
  ) => Actions;
}

export function createStore<State, Actions>(
  { state, actions }: StateCreatorOptions<State, Actions>,
  name: string,
  equalityFn = shallow
) {
  const storeCreator: StateCreator<
    State & { actions: Actions },
    [['zustand/immer', never], ['zustand/devtools', unknown]],
    [],
    State & { actions: Actions }
  > = (set, get) => ({
    ...state,
    actions: actions(set, get),
  });

  return createWithEqualityFn(
    immer(devtools(storeCreator, { name })),
    equalityFn
  );
}
